import FormattedMessage from 'I18n/components/FormattedMessage';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIBadge from 'UIComponents/badge/UIBadge';
import UIIcon from 'UIComponents/icon/UIIcon';
import Small from 'UIComponents/elements/Small';
import EditorShortcutLabel from 'automation-ui-canvas/components/flow-header/menu-bar/EditorShortcutLabel';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function makeMenuItem({
  option,
  nestedOptions,
  onOptionClick,
  flow,
  history,
  objectTypeId,
  help
}) {
  const dataTestId = `menu-option-${option.id}`;
  const label = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      justify: "between",
      children: [/*#__PURE__*/_jsxs("span", {
        children: [option.getLabel({
          objectTypeId
        }), option.external && /*#__PURE__*/_jsx(UIIcon, {
          className: "m-x-1",
          name: "externalLink"
        }), option.badge === 'new' && /*#__PURE__*/_jsx(UIBadge, {
          className: "m-x-1",
          use: "new",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.editorMenuBar.badge.new"
          })
        }), option.badge === 'beta' && /*#__PURE__*/_jsx(UIBadge, {
          className: "m-x-1",
          use: "beta",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "automation.editorMenuBar.badge.beta"
          })
        }), option.badge === 'notification' && /*#__PURE__*/_jsx(UIBadge, {
          className: "m-x-1",
          use: "dot",
          children: /*#__PURE__*/_jsx(_Fragment, {})
        })]
      }), 'shortcut' in option && /*#__PURE__*/_jsx(EditorShortcutLabel, {
        shortcut: option.shortcut
      })]
    }), help && /*#__PURE__*/_jsx(Small, {
      use: "help",
      className: "m-x-0",
      children: help
    })]
  });
  const ButtonComponent = option.ButtonComponent;
  if (ButtonComponent) {
    return /*#__PURE__*/_jsx(ButtonComponent, {
      "data-test-id": dataTestId,
      onClick: () => {
        if (onOptionClick) {
          onOptionClick(option);
        }
      },
      flow: flow,
      history: history,
      children: label
    });
  }
  return {
    label,
    // @ts-expect-error onClick is missing from UIMultiLevelDropdownProps.options
    onClick: () => {
      if (onOptionClick) {
        onOptionClick(option);
      }
    },
    options: nestedOptions,
    help,
    'data-test-id': dataTestId
  };
}